/**
 * Beacon léger de "vue de page" pour les statistiques d'usage admin
 * (quelles pages sont utilisées : bibliothèque, entraînement, chat, tables...).
 *
 * Volontairement fire-and-forget : ne bloque jamais l'UX, ignore les erreurs.
 */

import { useEffect, useRef } from 'react';
import { BACKEND_URL } from '../config';

export function usePageViewTracking(pseudo: string, token: string | undefined, page: string, compet?: boolean): void {
  const lastPageRef = useRef<string | null>(null);

  useEffect(() => {
    if (!pseudo || !token || !page || lastPageRef.current === page) return;
    lastPageRef.current = page;

    fetch(`${BACKEND_URL}/api/usage/page-view`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ pseudo, page, compet }),
      keepalive: true,
    }).catch(() => {
      // Silencieux : le tracking ne doit jamais impacter l'UX.
    });
  }, [pseudo, token, page, compet]);
}
